import React from 'react';
import { Link, NavLink, Navigate } from 'react-router-dom';
import { CurrencyDollar } from '@phosphor-icons/react';
import { useAuth } from '../contexts/AuthContext';

const publicLinks = [
  { to: '/', label: 'Home' },
  { to: '/features', label: 'Features' },
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact Us' },
];

export default function PublicSiteLayout({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (user) return <Navigate to="/dashboard" />;

  return (
    <div className="min-h-screen flex flex-col bg-[#F8F5F0] text-[#1C1B1A]">
      <header className="sticky top-0 z-30 border-b border-[#E8E6E1] bg-white/95 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-3 min-w-0">
            <div className="w-11 h-11 bg-[#1E3F2D] rounded-2xl flex items-center justify-center shadow-sm">
              <CurrencyDollar size={22} weight="fill" className="text-white" />
            </div>
            <div>
              <p className="text-xl font-extrabold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>Spell FinX</p>
              <p className="text-xs uppercase tracking-[0.18em] text-[#7A766E]">Personal Finance Hub</p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-2">
            {publicLinks.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) => `px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors ${isActive ? 'bg-[#F4EFE7] text-[#1C1B1A]' : 'text-[#5C5A56] hover:bg-[#F7F3ED] hover:text-[#1C1B1A]'}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link to="/register" className="hidden sm:inline-flex px-4 py-2.5 rounded-xl text-sm font-semibold text-[#1E3F2D] hover:bg-[#F5F1EB] transition-colors">
              Create Account
            </Link>
            <Link to="/login" className="inline-flex px-5 py-2.5 rounded-xl text-sm font-semibold bg-[#1E3F2D] text-white hover:bg-[#29563E] transition-colors">
              Login
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-[#E8E6E1] bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <p className="font-semibold text-[#1C1B1A]">Spell FinX</p>
            <p className="text-sm text-[#7A766E]">Track money clearly, plan better, and stay ahead of due dates.</p>
          </div>
          <div className="flex flex-wrap gap-4 text-sm text-[#5C5A56]">
            {publicLinks.map((item) => (
              <Link key={item.to} to={item.to} className="hover:text-[#1C1B1A] transition-colors">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
